import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface BottomNavProps {
  currentSlide: number;
  totalSlides: number;
  nextSlide: () => void;
  prevSlide: () => void;
}
export function BottomNav({
  currentSlide,
  totalSlides,
  nextSlide,
  prevSlide
}: BottomNavProps) {
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-gray-100 px-4 sm:px-6 lg:px-8 h-16 lg:h-20 flex items-center" data-id="element-7">
      <div className="max-w-7xl mx-auto w-full flex items-center justify-between" data-id="element-8">
        <button onClick={prevSlide} disabled={currentSlide === 0} className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-colors ${currentSlide === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-[#1a1a1a] hover:bg-gray-100'}`} data-id="element-9">
          <ChevronLeft className="w-5 h-5" data-id="element-10" />
          <span className="hidden sm:inline" data-id="element-11">Previous</span>
        </button>

        <div className="flex items-center gap-2" data-id="element-12">
          {Array.from({
          length: totalSlides
        }).map((_, idx) => <div key={idx} className={`h-1 rounded-full transition-all duration-300 ${idx === currentSlide ? 'w-6 bg-[#EB0A1E]' : idx < currentSlide ? 'w-3 bg-[#80BC41]/40' : 'w-3 bg-gray-200'}`} data-id="element-13" />)}
        </div>

        <button onClick={nextSlide} disabled={currentSlide === totalSlides - 1} className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${currentSlide === totalSlides - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-white bg-[#EB0A1E] hover:bg-[#c80819]'}`} data-id="element-14">
          <span className="hidden sm:inline" data-id="element-15">Next</span>
          <ChevronRight className="w-5 h-5" data-id="element-16" />
        </button>
      </div>
    </div>;
}